import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase'

const RIDDLES = [
  { id: 1, question: "I speak without a mouth and hear without ears. I have no body, but I come alive with wind. What am I?", answer: "echo" },
  { id: 2, question: "The more you take, the more you leave behind. What am I?", answer: "footsteps" },
  { id: 3, question: "I have cities, but no houses live there. I have mountains, but no trees grow there. I have water, but no fish swim there. I have roads, but no cars drive there. What am I?", answer: "map" },
  { id: 4, question: "I'm light as a feather, yet the strongest man can't hold me for more than five minutes. What am I?", answer: "breath" },
  { id: 5, question: "What has hands but can't clap?", answer: "clock" },
  { id: 6, question: "The more you have of it, the less you see. What is it?", answer: "darkness" },
  { id: 7, question: "I have no life, but I can die. What am I?", answer: "battery" },
  { id: 8, question: "What comes once in a minute, twice in a moment, but never in a thousand years?", answer: "m" },
  { id: 9, question: "I'm always hungry and must always be fed. The finger I touch will soon turn red. What am I?", answer: "fire" },
  { id: 10, question: "What has teeth but cannot bite?", answer: "comb" },
  { id: 11, question: "I'm tall when I'm young and short when I'm old. What am I?", answer: "candle" },
  { id: 12, question: "What can travel around the world while staying in one corner?", answer: "stamp" },
  { id: 13, question: "I have a head and a tail but no body. What am I?", answer: "coin" },
  { id: 14, question: "The more you remove from me, the bigger I get. What am I?", answer: "hole" },
  { id: 15, question: "What invention lets you look right through a wall?", answer: "window" },
  { id: 16, question: "I have branches but no fruit, trunk or leaves. What am I?", answer: "bank" },
  { id: 17, question: "What gets wetter the more it dries?", answer: "towel" },
  { id: 18, question: "I have an eye but cannot see. What am I?", answer: "needle" },
  { id: 19, question: "What has four legs in the morning, two at noon, and three at night?", answer: "human" },
  { id: 20, question: "I can be cracked, made, told, and played. What am I?", answer: "joke" },
  { id: 21, question: "What goes up but never comes down?", answer: "age" },
  { id: 22, question: "I'm not alive but I grow. I don't have lungs but I need air. I don't have a mouth but water kills me. What am I?", answer: "fire" },
  { id: 23, question: "What has one eye but cannot see?", answer: "needle" },
  { id: 24, question: "The person who makes it doesn't need it. The person who buys it doesn't use it. The person who uses it doesn't know they're using it. What is it?", answer: "coffin" },
  { id: 25, question: "What runs but never walks, has a mouth but never talks, has a head but never weeps, has a bed but never sleeps?", answer: "river" },
  { id: 26, question: "I have no wings but I can fly. I have no eyes but I can cry. What am I?", answer: "cloud" },
  { id: 27, question: "What is so fragile that saying its name breaks it?", answer: "silence" },
  { id: 28, question: "I'm always in front of you but can never be seen. What am I?", answer: "future" },
  { id: 29, question: "What has words but never speaks?", answer: "book" },
  { id: 30, question: "The more you feed it the more it grows, but water will kill it. What is it?", answer: "fire" },
]

function getTodaysRiddle() {
  const dayOfYear = Math.floor((new Date() - new Date(new Date().getFullYear(), 0, 0)) / 86400000)
  return RIDDLES[dayOfYear % RIDDLES.length]
}

function getTodaysId() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}

export default function DailyRiddle({ session }) {
  const navigate = useNavigate()
  const riddle = getTodaysRiddle()
  const todayId = getTodaysId()

  const [answer, setAnswer] = useState('')
  const [status, setStatus] = useState('unsolved') // unsolved | solved | wrong
  const [startTime] = useState(Date.now())
  const [solveTime, setSolveTime] = useState(null)
  const [elapsed, setElapsed] = useState(0)
  const [attempts, setAttempts] = useState(0)
  const [leaderboard, setLeaderboard] = useState([])
  const [myRank, setMyRank] = useState(null)
  const [alreadySolved, setAlreadySolved] = useState(false)
  const [shake, setShake] = useState(false)
  const [flicker, setFlicker] = useState(false)

  useEffect(() => {
    checkAlreadySolved()
    loadLeaderboard()
    // Candle flicker
    const fl = setInterval(() => setFlicker(f => !f), 2000 + Math.random() * 3000)
    return () => clearInterval(fl)
  }, [])

  useEffect(() => {
    if (status === 'unsolved' && !alreadySolved) {
      const t = setInterval(() => setElapsed(Math.floor((Date.now() - startTime) / 1000)), 1000)
      return () => clearInterval(t)
    }
  }, [status, alreadySolved])

  const checkAlreadySolved = async () => {
    if (!session?.user) return
    const { data } = await supabase.from('riddle_scores').select('*').eq('user_id', session.user.id).eq('riddle_date', todayId).single()
    if (data) {
      setAlreadySolved(true)
      setSolveTime(data.time_seconds)
      setStatus('solved')
    }
  }

  const loadLeaderboard = async () => {
    const { data } = await supabase
      .from('riddle_scores')
.select('member_number, display_name, time_seconds')
      .eq('riddle_date', todayId)
      .order('time_seconds', { ascending: true })
      .limit(5)
    setLeaderboard(data || [])
  }

  const handleSubmit = async () => {
    if (!answer.trim()) return
    const clean = answer.trim().toLowerCase()
    setAttempts(a => a + 1)

    if (clean === riddle.answer.toLowerCase()) {
      const time = Math.floor((Date.now() - startTime) / 1000)
      setSolveTime(time)
      setStatus('solved')

      if (session?.user) {
        const { data: memberData } = await supabase.from('members').select('member_number, display_name').eq('user_id', session.user.id).single()
        await supabase.from('riddle_scores').insert([{
          user_id: session.user.id,
          riddle_id: riddle.id,
          riddle_date: todayId,
          time_seconds: time,
          attempts: attempts + 1,
          member_number: memberData?.member_number,
          display_name: memberData?.display_name || null
        }])
        await loadLeaderboard()
        const { count } = await supabase.from('riddle_scores').select('*', { count: 'exact', head: true }).eq('riddle_date', todayId).lte('time_seconds', time)
        setMyRank(count)
      }
    } else {
      setStatus('wrong')
      setShake(true)
      setTimeout(() => { setShake(false); setStatus('unsolved') }, 600)
    }
  }

  const formatTime = (s) => {
    if (s < 60) return `${s}s`
    return `${Math.floor(s / 60)}m ${s % 60}s`
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'radial-gradient(ellipse at center top, #1a0a00 0%, #0d0500 40%, #000 100%)',
      color: '#c8862a',
      fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
      position: 'relative',
      overflow: 'hidden'
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Crimson+Text:ital,wght@0,400;0,600;1,400&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .stone-bg{position:fixed;inset:0;background-image:repeating-linear-gradient(0deg,transparent,transparent 40px,rgba(0,0,0,0.03) 40px,rgba(0,0,0,0.03) 41px),repeating-linear-gradient(90deg,transparent,transparent 40px,rgba(0,0,0,0.03) 40px,rgba(0,0,0,0.03) 41px);pointer-events:none;z-index:0}
        .ember1{position:fixed;width:300px;height:300px;border-radius:50%;background:radial-gradient(circle,rgba(200,100,20,0.12) 0%,transparent 70%);bottom:-100px;left:-100px;pointer-events:none;z-index:0;animation:emberglow 4s ease-in-out infinite}
        .ember2{position:fixed;width:200px;height:200px;border-radius:50%;background:radial-gradient(circle,rgba(180,80,10,0.08) 0%,transparent 70%);top:50px;right:-50px;pointer-events:none;z-index:0;animation:emberglow 6s ease-in-out infinite reverse}
        @keyframes emberglow{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.1);opacity:0.7}}
        .riddle-input{width:100%;background:rgba(200,134,42,0.06);border:none;border-bottom:2px solid rgba(200,134,42,0.3);color:#e8a84a;font-family:'Crimson Text',serif;font-size:18px;padding:14px 0;outline:none;transition:border-color 0.3s;letter-spacing:1px;text-align:center}
        .riddle-input:focus{border-color:rgba(200,134,42,0.8)}
        .riddle-input::placeholder{color:rgba(200,134,42,0.25);font-style:italic}
        .solve-btn{width:100%;background:rgba(200,134,42,0.15);border:1px solid rgba(200,134,42,0.4);color:#e8a84a;font-family:'Cinzel',serif;font-size:13px;letter-spacing:3px;padding:16px;cursor:pointer;transition:all 0.3s;margin-top:16px;text-transform:uppercase}
        .solve-btn:hover{background:rgba(200,134,42,0.25);border-color:rgba(200,134,42,0.8);box-shadow:0 0 20px rgba(200,134,42,0.15)}
        .back-btn{background:none;border:none;color:rgba(200,134,42,0.45);font-family:'Cinzel',serif;font-size:10px;letter-spacing:2px;cursor:pointer;padding:0;transition:color 0.2s}
        .back-btn:hover{color:rgba(200,134,42,0.8)}
        @keyframes shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-8px)}40%{transform:translateX(8px)}60%{transform:translateX(-6px)}80%{transform:translateX(6px)}}
        @keyframes solved{0%{opacity:0;transform:scale(0.95)}100%{opacity:1;transform:scale(1)}}
        .shake{animation:shake 0.5s ease}
        .divider{height:1px;background:linear-gradient(90deg,transparent,rgba(200,134,42,0.3),transparent);margin:24px 0}
        .lb-row{display:flex;justify-content:space-between;align-items:center;padding:10px 0;border-bottom:1px solid rgba(200,134,42,0.08);font-family:'Crimson Text',serif;font-size:15px}
        .lb-row:last-child{border-bottom:none}
      `}</style>

      <div className="stone-bg" />
      <div className="ember1" />
      <div className="ember2" />

      <div style={{ maxWidth: 520, margin: '0 auto', padding: '32px 24px 80px', position: 'relative', zIndex: 2 }}>

        {/* BACK + HEADER */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
          <button className="back-btn" onClick={() => navigate('/dashboard')}>← RETURN TO EXCHANGE</button>
          <div style={{ fontSize: 10, color: 'rgba(200,134,42,0.4)', letterSpacing: 2, fontFamily: "'Cinzel', serif" }}>{todayId}</div>
        </div>

        {/* CANDLE ICON */}
        <div style={{ textAlign: 'center', marginBottom: 8, fontSize: 36, opacity: flicker ? 0.9 : 1, transition: 'opacity 0.3s', filter: flicker ? 'brightness(0.85)' : 'brightness(1)' }}>🕯️</div>

        {/* TITLE */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontFamily: "'Cinzel', serif", fontSize: 28, color: '#e8a84a', letterSpacing: 4, fontWeight: 700, textShadow: '0 0 20px rgba(200,134,42,0.4)', marginBottom: 6 }}>
            THE DAILY RIDDLE
          </div>
          <div style={{ fontFamily: "'Crimson Text', serif", fontSize: 13, color: 'rgba(200,134,42,0.5)', letterSpacing: 3, fontStyle: 'italic' }}>
            One riddle. One day. One chance to be fastest.
          </div>
        </div>

        {/* STONE BORDER */}
        <div style={{ border: '1px solid rgba(200,134,42,0.2)', padding: '28px 24px', background: 'rgba(200,134,42,0.03)', position: 'relative', marginBottom: 28 }}>
          <div style={{ position: 'absolute', top: -1, left: 20, right: 20, height: 1, background: 'linear-gradient(90deg, transparent, rgba(200,134,42,0.5), transparent)' }} />
          <div style={{ position: 'absolute', bottom: -1, left: 20, right: 20, height: 1, background: 'linear-gradient(90deg, transparent, rgba(200,134,42,0.3), transparent)' }} />

          {/* TIMER */}
          {status === 'unsolved' && !alreadySolved && (
            <div style={{ textAlign: 'right', fontFamily: "'Cinzel', serif", fontSize: 11, color: 'rgba(200,134,42,0.4)', letterSpacing: 2, marginBottom: 16 }}>
              {formatTime(elapsed)}
            </div>
          )}

          {/* THE RIDDLE */}
          <div style={{ fontFamily: "'Crimson Text', serif", fontSize: 20, color: '#e8a84a', lineHeight: 1.75, textAlign: 'center', fontStyle: 'italic', marginBottom: 28, textShadow: '0 0 10px rgba(200,134,42,0.2)' }}>
            "{riddle.question}"
          </div>

          {/* UNSOLVED STATE */}
          {status !== 'solved' && !alreadySolved && (
            <div className={shake ? 'shake' : ''}>
              <input
                className="riddle-input"
                placeholder="whisper your answer..."
                value={answer}
                onChange={e => setAnswer(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                autoComplete="off"
              />
              {status === 'wrong' && (
                <div style={{ textAlign: 'center', fontFamily: "'Crimson Text', serif", fontStyle: 'italic', color: 'rgba(200,80,20,0.8)', fontSize: 14, marginTop: 10 }}>
                  The chamber remains silent. Try again.
                </div>
              )}
              <button className="solve-btn" onClick={handleSubmit}>
                Speak the Answer
              </button>
              {attempts > 0 && (
                <div style={{ textAlign: 'center', fontSize: 11, color: 'rgba(200,134,42,0.35)', fontFamily: "'Crimson Text', serif", marginTop: 10, fontStyle: 'italic' }}>
                  {attempts} {attempts === 1 ? 'attempt' : 'attempts'}
                </div>
              )}
            </div>
          )}

          {/* SOLVED STATE */}
          {(status === 'solved' || alreadySolved) && (
            <div style={{ animation: 'solved 0.5s ease', textAlign: 'center' }}>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: 32, color: '#e8a84a', letterSpacing: 2, marginBottom: 8, textShadow: '0 0 20px rgba(200,134,42,0.5)' }}>
                ✦ SOLVED ✦
              </div>
              <div style={{ fontFamily: "'Crimson Text', serif", fontSize: 18, color: 'rgba(200,134,42,0.8)', fontStyle: 'italic', marginBottom: 4 }}>
                The answer was <b style={{ color: '#e8a84a', fontStyle: 'normal' }}>{riddle.answer}</b>
              </div>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: 14, color: 'rgba(200,134,42,0.6)', letterSpacing: 2, marginTop: 8 }}>
                {formatTime(solveTime)}
                {myRank && <span style={{ marginLeft: 12, color: 'rgba(200,134,42,0.4)' }}>RANK #{myRank}</span>}
              </div>
            </div>
          )}
        </div>

        {/* LEADERBOARD */}
        {leaderboard.length > 0 && (
          <div>
            <div style={{ fontFamily: "'Cinzel', serif", fontSize: 11, letterSpacing: 3, color: 'rgba(200,134,42,0.5)', textAlign: 'center', marginBottom: 16, textTransform: 'uppercase' }}>
              Today's Fastest Solvers
            </div>
            <div style={{ border: '1px solid rgba(200,134,42,0.12)', padding: '4px 16px' }}>
              {leaderboard.map((row, i) => (
                <div key={i} className="lb-row">
                  <span style={{ color: i === 0 ? '#e8a84a' : 'rgba(200,134,42,0.5)' }}>
                    {i === 0 ? '✦' : `${i + 1}.`} &nbsp; {row.display_name || `Member #${row.member_number || '???'}`}
                  </span>
                  <span style={{ color: i === 0 ? '#e8a84a' : 'rgba(200,134,42,0.4)', fontFamily: "'Cinzel', serif", fontSize: 13, letterSpacing: 1 }}>
                    {formatTime(row.time_seconds)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* FOOTER */}
        <div style={{ textAlign: 'center', marginTop: 40, fontFamily: "'Crimson Text', serif", fontStyle: 'italic', fontSize: 12, color: 'rgba(200,134,42,0.25)', letterSpacing: 1 }}>
          A new riddle appears at midnight
        </div>

      </div>
    </div>
  )
}
